import React from 'react';

const CounterBadge = ({ item }) => {
    const faultCount = item?.faultCount ?? 0;
    const alarmCount = item?.alarmCount ?? 0;
    const total = faultCount + alarmCount;

    return (
        <span
            className={`inline-flex h-6 w-6 items-center justify-center rounded-full font-bold ${
                total === 0
                    ? 'bg-muted/60 text-muted-foreground'
                    : faultCount > 0
                      ? 'bg-error text-error-foreground'
                      : 'bg-warning text-warning-foreground'
            }`}
        >
            {total}
        </span>
    );
};

export default CounterBadge;
